// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3DWrv","content":"RecentSearches_content__38xFr"};